import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { class: "meeting-calendar-toolbar" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar mr-1" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Today ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left date-change-icon cursor-pointer" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "black-text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right date-change-icon cursor-pointer" }, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "d-flex align-items-center justify-content-end w-20" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "dayGridMonth" }, "Month", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "timeGridWeek" }, "Week", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "timeGridDay" }, "Day", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-outline-primary border-0 fw-semibold px-2 py-1 me-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToday && _ctx.goToday(...args)))
        }, _hoisted_6),
        _createElementVNode("span", {
          class: "cursor-pointer px-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goPrev && _ctx.goPrev(...args)))
        }, _hoisted_8),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.dateRangeLabel), 1 /* TEXT */),
        _createElementVNode("span", {
          class: "cursor-pointer px-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goNext && _ctx.goNext(...args)))
        }, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select px-2 py-1",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedView) = $event)),
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeView && _ctx.changeView(...args)))
        }, _hoisted_16, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.selectedView]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary px-2 py-1 ms-3 text-nowrap",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleNewEventClick && _ctx.handleNewEventClick(...args)))
        }, " New Event ")
      ])
    ]),
    _createVNode(_component_FullCalendar, {
      id: "Meeting__Calendar",
      ref: "meetingCalendar",
      class: "h-100 w-100",
      options: _ctx.calendarOptions
    }, null, 8 /* PROPS */, ["options"])
  ]))
}